import request from '@/utils/request'

export function login (data) {
  return request({
    url: '/osp/web/login',
    method: 'post',
    data: data
  })
}

export function logout () {
  return request({
    url: '/osp/logout',
    method: 'post'
  })
}

export function resetPassword (data) {
  return request({
    url: '/osp/resetPassword',
    method: 'post',
    data: data
  })
}

export function changePassword (data) {
  return request({
    url: '/osp/changePassword',
    method: 'post',
    data: data
  })
}

export function getUserInfo () {
  return request({
    url: '/osp/getUserInfo',
    method: 'post',
  })
}

export function getCompanyInfos(){
  return request({
    url: '/osp/org-company/queryByFinanceUserId',
    method: 'post'
  })
}

export function getSaleInfos(){
  return request({
    url: '/osp/org-sale/queryByCustomerId',
    method: 'post'
  })
}

export function getSaleOrgsBySaler(){
  return request({
    url: '/osp/org-sale/queryBySalerId',
    method: 'post'
  })
}
